import React from 'react';
import AsyncTerms from './async';
import DefaultBusinessLayout from '../../../../../components/layout/DefaultBusinessLayout';

export default (
  <DefaultBusinessLayout
    key="/business/shopify/terms"
    exact
    path="/business/shopify/terms"
    component={AsyncTerms}
    breadcrumb={[
      {
        position: 1,
        name: 'Home',
        item: '/',
      },
      {
        position: 2,
        name: 'Business',
        item: '/business',
      },
      {
        position: 3,
        name: 'Shopify Terms',
        item: '/business/shopify/terms',
      },
    ]}
  />
);
